module.exports = __webpack_public_path__ + "static/sapiens-080a27c2e192981c3cc5079cb89ec583.jpg";